/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/frigate_4': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 12.336V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086L31.414 16l-3.664-3.664zm-.5-7.586v7.086L20.164 4.75h7.086zm-22.5 0h7.086L4.75 11.836V4.75zm0 22.5v-7.086l7.086 7.086H4.75zm22.5 0h-7.086l7.086-7.086v7.086zM16 28.586L3.414 16 16 3.414 28.586 16 16 28.586z"/><path pid="1" d="M17.363 20.771l1.363-.682v-8.182l-.682-.682L16.682 8.5h-1.363l-1.364 2.728-.682.682v8.182l1.364.682h2.726v-.003zm-3.409-5.453h1.364v-1.364h1.364v1.364h1.363v1.364h-1.363v1.363h-1.364v-1.363h-1.364v-1.364zM14.637 22.818h2.726v.682h-2.726z"/><path pid="2" d="M20.091 13.954v-1.363l-.682-.682V21.454h-6.818v-9.545l-.682.682v1.363a2.047 2.047 0 000 4.092v4.091h8.182v-4.091a2.047 2.047 0 000-4.092z"/>'
  }
})
